import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from 'ag-grid-community';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from "@ng-bootstrap/ng-bootstrap";
import { RouterLink } from "@angular/router";
import { IndividualRelationshipGroupModel } from "../../models/individual-relationship-group-model";
import {
  AgActionIconButtonComponent
} from "@shared/components/grid/ag-cells/common/ag-action-icon-button/ag-action-icon-button.component";
import { EntityType } from "@models/common/entity-type.enum";
import { Guid } from "../../../../../../shared/utils/guid.helper";
import { getCompanyProfilePath, getTrustProfilePath } from "../../../../../../shared/utils/route-path-utils";

type IIndividualEntityActionFn = (groupModel: IndividualRelationshipGroupModel | undefined) => void;
type ICellParams = ICellRendererParams<IndividualRelationshipGroupModel> & {
  onUpdateContactDetails: IIndividualEntityActionFn,
  splitIndividualsToNew: IIndividualEntityActionFn,
  onAssignIndividualsToExisting: IIndividualEntityActionFn,
  onChangeName: IIndividualEntityActionFn,
  onChangeAddress: IIndividualEntityActionFn,
  onMistakeCorrection: IIndividualEntityActionFn,
};

@Component({
  selector: 'app-ag-individual-relationship-actions',
  standalone: true,
  imports: [
    AgActionIconButtonComponent,
    NgbDropdown,
    NgbDropdownItem,
    NgbDropdownMenu,
    NgbDropdownToggle,
    RouterLink
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: 'ag-individual-relationship-actions.component.html',
})
export class AgIndividualRelationshipActionsComponent implements ICellRendererAngularComp {
  params: ICellParams | null = null;
  entityIcon = signal<string>('');
  entityLink = signal<string[] | null>(null);
  isCompany = signal<boolean>(false);

  agInit(params: ICellParams): void {
    this.updateParams(params);
  }

  refresh(params: ICellParams): boolean {
    return this.updateParams(params);
  }

  showActionMenu(): boolean {
    return this.params?.data?.isResigned === false;
  }

  updateParams(params: ICellParams): boolean {
    this.params = params;
    this.isCompany.set(params.data?.relatedToEntityType == EntityType.Company);
    this.entityLink.set(this.getEntityLink(params.data?.entityId));
    this.entityIcon.set(this.getEntityIcon());

    return true;
  }

  onUpdateContactDetails(): void {
    this.params?.onUpdateContactDetails(this.params?.data);
  }

  splitIndividualsToNew(): void {
    this.params?.splitIndividualsToNew(this.params?.data);
  }

  onAssignIndividualsToExisting(): void {
    this.params?.onAssignIndividualsToExisting(this.params?.data);
  }

  onChangeName(): void {
    this.params?.onChangeName(this.params?.data);
  }

  onChangeAddress(): void {
    this.params?.onChangeAddress(this.params?.data);
  }

  onMistakeCorrection(): void {
    this.params?.onMistakeCorrection(this.params?.data);
  }

  private getEntityIcon(): string {
    return this.isCompany()
      ? 'ic-companies-20'
      : 'ic-trusts-20';
  }

  private getEntityLink(entityId: string | undefined): string[] | null{

    if(entityId == undefined || entityId == Guid.EmptyGuid)
      return null;

    if (this.isCompany()) {
      return getCompanyProfilePath(entityId);
    }

    return getTrustProfilePath(entityId);
  }
}
